import React, { useRef, useState, useEffect } from 'react'
import PlayCircleRoundedIcon from '@mui/icons-material/PlayCircleRounded'
import {
  CIRCLE,
  EXTRA_SMALL_PEN,
  LARGE_PEN,
  LINE,
  MEDIUM_PEN,
  PEN,
  RECT,
  SMALL_PEN
} from '../constants'
import { KnovaText } from '../BasicUIComponents/KnovaText'

function SketchPad(props) {
  const {
    // canvasDimension,
    fromLayout,
    InkJson,
    themeColors,
    currentStrokeData,
    currentSketchIndex,
    isSketchAreaChanged,
    sketchPadInitial,
    strokeColor,
    isReplayMode,
    strokeReplayStarted,
    sketchType,
    strokeWidth,
    isSideMenu
  } = props
  const { onStrokeDataCapture, getStrokeReplayFinished, onSketchDisplayed } =
    props

  // const contextRef = useRef(null)
  const canvasRef = useRef(null)
  const isDrawing = useRef(false)
  const [context, setContext] = useState(null)
  const [contextRef, setContextRef] = useState(null)
  const [pointsArray, setpointsArray] = useState([])
  const [strokeArray, setStrokeArray] = useState([])
  const [strokeActions, setStrokeActions] = useState([])
  const [sketchIndex, setSketchIndex] = useState(0)

  const [replayCount, setreplayCount] = useState(0)
  const [timer, setTimer] = useState(undefined)

  const headModalContainer = useRef()
  const [canvasDimension, setCanvasAreaDimensions] = useState({
    width: 0,
    height: 0
  })

  //get canvas width and height
  useEffect(() => {
    if (headModalContainer && headModalContainer.current) {
      var ansContWidth = headModalContainer.current.clientWidth
      var ansContHeight = headModalContainer.current.clientHeight
      let canvasAreaDimensions = {
        width: ansContWidth,
        height: ansContHeight
      }
      setCanvasAreaDimensions(canvasAreaDimensions)
    }
  }, [])

  useEffect(() => {
    if (fromLayout && contextRef) {
      console.log('InkJson', InkJson)
      if (InkJson && InkJson !== '') {
        if (InkJson.length > 0) {
          let strokeArrayCopy = InkJson[0].strokeArray
          let strokeActionCopy = InkJson[0].strokeActions
          setStrokeArray(strokeArrayCopy)
          setStrokeActions(strokeActionCopy)
          addAllPaths(strokeArrayCopy, true)
        }
      }
    }
  }, [contextRef])

  //Set height and width for canvas
  useEffect(() => {
    if (canvasRef.current && canvasRef.current !== null) {
      const canvas = canvasRef.current
      canvas.width = canvasDimension.width
      canvas.height = canvasDimension.height
      canvas.style.width = `${canvasDimension.width}px`
      canvas.style.height = `${canvasDimension.height}px`
      setContext(canvas.getContext('2d'))
    }
  }, [canvasRef, canvasDimension])

  //   useEffect(() => {
  //     setSketchIndex(currentSketchIndex)
  //   }, [currentSketchIndex])

  function setStrokeData() {
    if (
      currentStrokeData.strokeData.length !== 0 &&
      currentStrokeData.strokeActions.length !== 0
    ) {
      // clearCanvas()
      setStrokeArray(currentStrokeData.strokeData)
      setStrokeActions(currentStrokeData.strokeActions)
      addAllPaths(currentStrokeData.strokeData, true)
    } else {
      clearCanvas()
      setStrokeArray([])
      setStrokeActions([])
    }
  }

  useEffect(() => {
    if (isSketchAreaChanged) {
      setStrokeData()
    }
  }, [isSketchAreaChanged])

  useEffect(() => {
    if (contextRef && contextRef !== null) {
      if (sketchPadInitial) {
        setStrokeData()
        onSketchDisplayed()
      }
    }
  }, [contextRef])

  //   useEffect(() => {
  //     if (currentStrokeData) {
  //       console.log('currentSketchIndex', currentSketchIndex)
  //       console.log('currentStrokeData', currentStrokeData)

  //     }
  //   }, [sketchIndex])

  //Set canvas sttroke properties
  useEffect(() => {
    if (context) {
      context.lineCap = 'round'
      context.strokeStyle = strokeColor
      context.lineWidth = 5
      setContextRef(context)
      // contextRef = context
      // console.log('contextRef', context)
    }
  }, [context, strokeColor])

  //Set delay for strokes
  function sleep(ms) {
    return new Promise((resolve) => setTimer(setTimeout(resolve, ms)))
  }

  //Start the replay function when replay button clicked on header
  useEffect(() => {
    if (strokeReplayStarted) {
      replayCurrentRectangle()
    }
  }, [strokeReplayStarted])

  //Replay stroke
  async function replayCurrentRectangle() {
    let strokeActionCopy = [...strokeActions]
    let strokeArrayCopy = [...strokeArray]
    let allReplayStrokes = []
    //Display strokes inside the replay box one by one
    let replayValue = 0
    let currentReplayStrokeIndex = 0
    if (replayCount > 0) {
      //Display already played strokes and shapes
      for (let index = 0; index < replayCount; index++) {
        const { StrokeID, Action } = strokeActionCopy[index]
        if (Action === 'add') {
          const strokeIndex = strokeArray.findIndex(
            (x) => parseInt(x.id) === parseInt(StrokeID)
          )
          if (strokeIndex >= 0) {
            replayValue = 0
            allReplayStrokes.push(strokeArray[strokeIndex])
          }
        } else {
          replayValue = 0
          allReplayStrokes = allReplayStrokes.filter(
            (obj) => parseInt(obj.id) !== parseInt(StrokeID)
          )
        }
        await sleep(0).then(() => {
          if (replayValue === 0) {
            addAllPathsForReplay(allReplayStrokes, true)
          }
          setreplayCount(index)
        })
      }
      currentReplayStrokeIndex = replayCount
    } else {
      currentReplayStrokeIndex = 0
    }
    for (
      let index = currentReplayStrokeIndex;
      index < strokeActionCopy.length;
      index++
    ) {
      const { StrokeID, Action } = strokeActionCopy[index]
      if (Action === 'add') {
        const strokeIndex = strokeArray.findIndex(
          (x) => parseInt(x.id) === parseInt(StrokeID)
        )
        if (strokeIndex >= 0) {
          replayValue = 0
          allReplayStrokes.push(strokeArray[strokeIndex])
        }
      }
      await sleep(500).then(() => {
        if (replayValue === 0) {
          addAllPathsForReplay(allReplayStrokes, true)
        }
        setreplayCount(index)
      })
    }
    clearCanvas()
    addAllPaths(strokeArray, false)
    setreplayCount(0)
    getStrokeReplayFinished()
  }

  function convertToLine(points) {
    return [
      { x: points[0].x, y: points[0].y },
      {
        x: (points[0].x + points[points.length - 1].x) / 2,
        y: (points[0].y + points[points.length - 1].y) / 2
      },
      {
        x: (points[0].x + points[1].x) / 2,
        y: (points[0].y + points[1].y) / 2
      },
      {
        x: (points[points.length - 1].x + points[1].x) / 2,
        y: (points[points.length - 1].y + points[1].y) / 2
      },
      { x: points[points.length - 1].x, y: points[points.length - 1].y }
    ]
  }

  function convertToRectangle(points) {
    const updatedPoints = []
    const xArray = points.map((p) => p.x)
    const yArray = points.map((p) => p.y)
    const init = { x: Math.min(...xArray), y: Math.min(...yArray) }
    const end = { x: Math.max(...xArray), y: Math.max(...yArray) }
    let line1 = { x: init.x, y: init.y }
    let line11 = { x: (init.x + end.x) / 2, y: (init.y + init.y) / 2 }
    let varLine101x = (init.x + (init.x + end.x) / 2) / 2
    let varLine101y = (init.y + (init.y + init.y) / 2) / 2
    let line101 = { x: varLine101x, y: varLine101y }
    let varLine102x = (end.x + (init.x + end.x) / 2) / 2
    let varLine102y = (init.y + (init.y + init.y) / 2) / 2
    let line102 = { x: varLine102x, y: varLine102y }
    let line12 = { x: end.x, y: init.y }
    updatedPoints.push(line1)
    updatedPoints.push(line101)
    updatedPoints.push(line11)
    updatedPoints.push(line102)
    updatedPoints.push(line12)
    let line2 = { x: end.x, y: init.y }
    let line21 = { x: (end.x + end.x) / 2, y: (init.y + end.y) / 2 }
    let varLine201x = (end.x + (end.x + end.x) / 2) / 2
    let varLine201y = (init.y + (init.y + end.y) / 2) / 2
    let line201 = { x: varLine201x, y: varLine201y }
    let varLine202x = (end.x + (end.x + end.x) / 2) / 2
    let varLine202y = (end.y + (init.y + end.y) / 2) / 2
    let line202 = { x: varLine202x, y: varLine202y }
    let line22 = { x: end.x, y: end.y }
    updatedPoints.push(line2)
    updatedPoints.push(line201)
    updatedPoints.push(line21)
    updatedPoints.push(line202)
    updatedPoints.push(line22)
    let line3 = { x: end.x, y: end.y }
    let line31 = { x: (end.x + init.x) / 2, y: (end.y + end.y) / 2 }
    let varLine301x = (end.x + (end.x + init.x) / 2) / 2
    let varLine301y = (end.y + (end.y + end.y) / 2) / 2
    let line301 = { x: varLine301x, y: varLine301y }
    let varLine302x = (init.x + (end.x + init.x) / 2) / 2
    let varLine302y = (end.y + (end.y + end.y) / 2) / 2
    let line302 = { x: varLine302x, y: varLine302y }
    let line32 = { x: init.x, y: end.y }
    updatedPoints.push(line3)
    updatedPoints.push(line301)
    updatedPoints.push(line31)
    updatedPoints.push(line302)
    updatedPoints.push(line32)
    let line4 = { x: init.x, y: end.y }
    let line41 = { x: (init.x + init.x) / 2, y: (end.y + init.y) / 2 }
    let varLine401x = (init.x + (init.x + init.x) / 2) / 2
    let varLine401y = (end.y + (end.y + init.y) / 2) / 2
    let line401 = { x: varLine401x, y: varLine401y }
    let varLine402x = (init.x + (init.x + init.x) / 2) / 2
    let varLine402y = (init.y + (end.y + init.y) / 2) / 2
    let line402 = { x: varLine402x, y: varLine402y }
    let line42 = { x: init.x, y: init.y }
    updatedPoints.push(line4)
    updatedPoints.push(line401)
    updatedPoints.push(line41)
    updatedPoints.push(line402)
    updatedPoints.push(line42)
    return updatedPoints
  }

  function convertToCircle(points) {
    const xArray = points.map((p) => p.x)
    const yArray = points.map((p) => p.y)
    const init = [Math.min(...xArray), Math.min(...yArray)]
    const end = [Math.max(...xArray), Math.max(...yArray)]
    const centerPoint = [(init[0] + end[0]) / 2, (init[1] + end[1]) / 2]
    const newRadius1 =
      (centerPoint[0] - init[0] + (end[0] - centerPoint[0])) / 2
    const newRadius2 =
      (centerPoint[1] - init[1] + (end[1] - centerPoint[1])) / 2
    const newRadius = (newRadius1 + newRadius2) / 2
    const updatedPoints = getCirclePoints(
      centerPoint[0],
      centerPoint[1],
      newRadius
    )
    return updatedPoints
  }

  function getCirclePoints(x0, y0, radius) {
    const pointsArray = []
    for (let i = 0; i <= 360; i = i + 1) {
      pointsArray.push({
        x: x0 + radius * Math.cos(degrees_to_radians(i)),
        y: y0 + radius * Math.sin(degrees_to_radians(i))
      })
    }
    return pointsArray
  }

  function degrees_to_radians(degrees) {
    const pi = Math.PI
    return degrees * (pi / 180)
  }

  //Capture student strokes functionalities
  const startDrawing = ({ nativeEvent }) => {
    isDrawing.current = true
    const { offsetX, offsetY } = nativeEvent
    contextRef.beginPath()
    pointsArray.push({ x: offsetX, y: offsetY, isDragging: false })
    contextRef.moveTo(offsetX, offsetY)
    //  setstartTime(minutes + ":" + seconds);
  }

  const finishDrawing = () => {
    if (isDrawing.current === true) {
      contextRef.closePath()
      isDrawing.current = false
      let strokeArrayCopy = [...strokeArray]
      if (pointsArray.length === 1) {
        pointsArray.push({
          x: pointsArray[0].x,
          y: pointsArray[0].y,
          isDragging: false
        })
      }
      let dataValue = []
      if (sketchType === LINE) {
        dataValue = convertToLine(pointsArray)
      } else if (sketchType === RECT) {
        dataValue = convertToRectangle(pointsArray)
      } else if (sketchType === CIRCLE) {
        dataValue = convertToCircle(pointsArray)
      } else {
        dataValue = pointsArray
      }
      let strokeUuid = Date.now()
      const stroke = {
        id: strokeUuid,
        points: dataValue,
        color: strokeColor,
        width: 5,
        isDeleted: false
        // userId: user.LoginID,
        // startTime: startTime,
        // elapsedTime: minutes + ':' + seconds,
        // type:
        //   currentShape === SHAPE_NAME.PEN
        //     ? STROKE_TYPE.STROKE
        //     : STROKE_TYPE.SHAPE
      }
      //  setstartTime("");
      strokeArrayCopy.push(stroke)
      setStrokeArray(strokeArrayCopy)
      let strokeAction = {
        Action: 'add',
        StrokeID: strokeUuid
        // elapsedTime: minutes + ':' + seconds
      }
      let strokeActionsCopy = [...strokeActions]
      strokeActionsCopy.push(strokeAction)
      setStrokeActions(strokeActionsCopy)
      onStrokeDataCapture(strokeArrayCopy, strokeActionsCopy)
      setpointsArray([])
      addAllPaths(strokeArrayCopy, true)
      //addAllPathsForTeacher(editorStrokeData)
    }
  }

  const draw = ({ nativeEvent }) => {
    // if (currentMode === CANVAS_MODE.PEN) {
    const { offsetX, offsetY } = nativeEvent
    if (!isDrawing.current) {
      return
    }

    contextRef.lineTo(offsetX, offsetY)
    pointsArray.push({ x: offsetX, y: offsetY, isDragging: false })
    contextRef.stroke()
    //   if (isReplaySequenceTimerStart) {
    //     setIsReplaySequence(false);
    //   }
    // }
  }

  const clearCanvas = () => {
    if (contextRef) {
      contextRef.clearRect(0, 0, canvasDimension.width, canvasDimension.height)
    }
  }

  const addPath = (pointsArray) => {
    contextRef.beginPath()
    contextRef.moveTo(pointsArray[0].x, pointsArray[0].y)
    pointsArray.forEach((point) => {
      contextRef.lineTo(point.x, point.y)
      // contextRef.scale(1.02, 1.02);
      contextRef.stroke()
    })
    contextRef.closePath()
  }

  const addAllPaths = (customArray, clear) => {
    if (clear) {
      clearCanvas()
    }
    // console.log('customArray', contextRef)
    customArray.forEach((stroke) => {
      if (!stroke.isDeleted) {
        contextRef.strokeStyle = stroke.color
        switch (stroke.width) {
          case 1.5:
            contextRef.lineWidth = EXTRA_SMALL_PEN
            break
          case 3:
            contextRef.lineWidth = SMALL_PEN
            break
          case 8:
            contextRef.lineWidth = LARGE_PEN
            break
          case 10:
            contextRef.lineWidth = LARGE_PEN
            break
          default:
            contextRef.lineWidth = MEDIUM_PEN
            break
        }
        if (stroke.points.length > 0) {
          addPath(stroke.points)
        }
      }
    })
  }

  const addAllPathsForReplay = (customArray, clear) => {
    if (clear) {
      clearCanvas()
    }
    customArray.forEach((stroke) => {
      contextRef.strokeStyle = stroke.color
      switch (stroke.width) {
        case 1.5:
          contextRef.lineWidth = EXTRA_SMALL_PEN
          break
        case 3:
          contextRef.lineWidth = SMALL_PEN
          break
        case 8:
          contextRef.lineWidth = LARGE_PEN
          break
        case 10:
          contextRef.lineWidth = LARGE_PEN
          break
        default:
          contextRef.lineWidth = MEDIUM_PEN
          break
      }
      if (stroke.points.length > 0) {
        addPath(stroke.points)
      }
    })
  }

  return (
    <div
      ref={headModalContainer}
      className='sketch-pad-container'
      style={{
        borderWidth: fromLayout ? '2px' : '0px',
        borderStyle: fromLayout ? 'solid' : 'unset',
        borderColor: fromLayout ? themeColors.outline : 'unset',
        backgroundColor: fromLayout ? themeColors.backgroundContainer : 'unset',
        borderRadius: isSideMenu ? '5px' : fromLayout ? '12px' : '0px'
      }}
    >
      {!isSideMenu && (
        <canvas
          ref={canvasRef}
          className='sketch-pad-canvas'
          onMouseDown={(event) => {
            startDrawing(event)
            // if (currentMode === CANVAS_MODE.PEN) {
            //   startDrawing(event);
            // }
          }}
          onMouseUp={(event) => {
            finishDrawing(event)
            // if (currentMode === CANVAS_MODE.PEN) {
            //   finishDrawing(event);
            // }
          }}
          onMouseMove={(event) => {
            draw(event)
            // if (currentMode === CANVAS_MODE.PEN) {
            //   draw(event);
            // }
          }}
          onMouseOut={(event) => {
            finishDrawing(event)
            // if (currentMode === CANVAS_MODE.PEN) {
            //   finishDrawing(event);
            // }
          }}
        />
      )}
      {isSideMenu && strokeActions.length === 0 && (
        <KnovaText
          contMargin='5px'
          text='Replay work area'
          textFontSize='5px'
          textColor={themeColors.onBackgroundContainer}
          textOpacity={0.3}
        />
      )}
      {/* {isReplayMode && (
        <span
          className='replay-play-icon-container'
          style={{ zIndex: 6, cursor: 'pointer' }}
          onClick={() => {
            window.speechSynthesis.cancel()
            replayCurrentRectangle()
          }}
        >
          <span className='replay-play-icon-color-circle'>
            <PlayCircleRoundedIcon
              style={{ color: 'white', width: '30px', height: '30px' }}
            />
          </span>
        </span>
      )} */}
    </div>
  )
}
export { SketchPad }
